module.exports = __webpack_public_path__ + "static/media/bottleshot_magnanime.eaa3db03.png";